import {
  ACTIVITY_DM_CONVERSATION_CREATED_EVENT,
  CRM_ACTIVITY_EVENT_TYPES,
} from './constants';

/**
 * Флаги поведения для activity-событий.
 * Display text формируется хендлером (payload.system_text) — здесь только флаги.
 */

/**
 * Список event_type, которые не должны отображаться как отдельные сообщения чата.
 */
export const ACTIVITY_HIDDEN_CHAT_EVENT_TYPES: string[] = [
  CRM_ACTIVITY_EVENT_TYPES.COMMENT_UPDATED,
  CRM_ACTIVITY_EVENT_TYPES.COMMENT_DELETED,
  // genesis-событие DM-треда — техническое, в чате не показывается
  ACTIVITY_DM_CONVERSATION_CREATED_EVENT,
];

/**
 * События, относящиеся к жизненному циклу комментария.
 */
export const ACTIVITY_COMMENT_EVENT_TYPES: readonly string[] = [
  CRM_ACTIVITY_EVENT_TYPES.COMMENT_ADDED,
  CRM_ACTIVITY_EVENT_TYPES.COMMENT_UPDATED,
  CRM_ACTIVITY_EVENT_TYPES.COMMENT_DELETED,
];

const ACTIVITY_COMMENT_EVENT_TYPES_SET = new Set<string>(ACTIVITY_COMMENT_EVENT_TYPES);

/**
 * Проверяет, что event_type относится к событиям комментариев.
 */
export function isActivityCommentEvent(eventType: string): boolean {
  return ACTIVITY_COMMENT_EVENT_TYPES_SET.has(eventType);
}
